import { render, staticRenderFns } from "./LibraryHeader.vue?vue&type=template&id=32cbf012&scoped=true"
import script from "./LibraryHeader.vue?vue&type=script&lang=js"
export * from "./LibraryHeader.vue?vue&type=script&lang=js"
import style0 from "./LibraryHeader.vue?vue&type=style&index=0&id=32cbf012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cbf012",
  null
  
)

export default component.exports